

const User = ()=>{


    return (
        <><h4>the page for user CRUD</h4></>
    );
};

export default User;